// CPU_DATA_GEN ordenado 1st->14th, Ryzen 2000->8000, Apple M1->M4
const CPU_DATA_GEN = {
    "AMD": {
        "Ryzen 7": {
            "Ryzen 2000 (Zen)": [
                "Ryzen 7 2700U"
            ],
            "Ryzen 3000 (Zen+)": [
                "Ryzen 7 3700U",
                "Ryzen 7 3750H"
            ],
            "Ryzen 4000 (Zen 2)": [
                "Ryzen 7 4800H",
                "Ryzen 7 4800U"
            ],
            "Ryzen 5000 (Zen 3)": [
                "Ryzen 7 5800H",
                "Ryzen 7 5800U"
            ],
            "Ryzen 6000 (Zen 3+)": [
                "Ryzen 7 6800H",
                "Ryzen 7 6800U"
            ],
            "Ryzen 8000 (Zen 4/4c)": [
                "Ryzen 7 8845HS",
                "Ryzen 7 8840U"
            ],
            "Ryzen 7000 (Zen 4/3+)": [
                "Ryzen 7 7840HS",
                "Ryzen 7 7840U",
                "Ryzen 7 7730U"
            ]
        },
        "Ryzen 5": {
            "Ryzen 2000 (Zen)": [
                "Ryzen 5 2500U"
            ],
            "Ryzen 3000 (Zen+)": [
                "Ryzen 5 3500U",
                "Ryzen 5 3550H"
            ],
            "Ryzen 4000 (Zen 2)": [
                "Ryzen 5 4600H",
                "Ryzen 5 4600U"
            ],
            "Ryzen 5000 (Zen 3)": [
                "Ryzen 5 5600H",
                "Ryzen 5 5600U"
            ],
            "Ryzen 6000 (Zen 3+)": [
                "Ryzen 5 6600H",
                "Ryzen 5 6600U"
            ],
            "Ryzen 8000 (Zen 4/4c)": [
                "Ryzen 5 8645HS",
                "Ryzen 5 8640U"
            ],
            "Ryzen 7000 (Zen 4/3+)": [
                "Ryzen 5 7640HS",
                "Ryzen 5 7530U"
            ]
        },
        "Ryzen 3": {
            "Ryzen 2000 (Zen)": [
                "Ryzen 3 2300U",
                "Ryzen 3 2200U"
            ],
            "Ryzen 3000 (Zen+)": [
                "Ryzen 3 3300U",
                "Ryzen 3 3200U"
            ],
            "Ryzen 4000 (Zen 2)": [
                "Ryzen 3 4300U"
            ],
            "Ryzen 5000 (Zen 3)": [
                "Ryzen 3 5300U"
            ],
            "Ryzen 7000 (Zen 4/3+)": [
                "Ryzen 3 7330U"
            ]
        },
        "Ryzen 9": {
            "Ryzen 4000 (Zen 2)": [
                "Ryzen 9 4900HS"
            ],
            "Ryzen 5000 (Zen 3)": [
                "Ryzen 9 5980HX",
                "Ryzen 9 5900HX"
            ],
            "Ryzen 6000 (Zen 3+)": [
                "Ryzen 9 6900HX"
            ],
            "Ryzen 8000 (Zen 4/4c)": [
                "Ryzen 9 8945HS"
            ],
            "Ryzen 7000 (Zen 4/3+)": [
                "Ryzen 9 7945HX",
                "Ryzen 9 7940HS"
            ]
        }
    },
    "Intel": {
        "Core i7": {
            "1st Gen (Arrandale/Clarksfield)": [
                "Core i7-940XM",
                "Core i7-920XM",
                "Core i7-840QM",
                "Core i7-820QM",
                "Core i7-740QM",
                "Core i7-720QM",
                "Core i7-640M",
                "Core i7-620M",
                "Core i7-640LM",
                "Core i7-620LM",
                "Core i7-640UM",
                "Core i7-620UM"
            ],
            "2nd Gen (Sandy Bridge)": [
                "Core i7-2860QM",
                "Core i7-2760QM",
                "Core i7-2720QM",
                "Core i7-2670QM",
                "Core i7-2640M",
                "Core i7-2620M",
                "Core i7-2637M",
                "Core i7-2677M"
            ],
            "3rd Gen (Ivy Bridge)": [
                "Core i7-3940XM",
                "Core i7-3840QM",
                "Core i7-3820QM",
                "Core i7-3740QM",
                "Core i7-3720QM",
                "Core i7-3667U",
                "Core i7-3517U",
                "Core i7-3540M",
                "Core i7-3520M"
            ],
            "4th Gen (Haswell)": [
                "Core i7-4930MX",
                "Core i7-4900MQ",
                "Core i7-4800MQ",
                "Core i7-4702HQ",
                "Core i7-4710HQ",
                "Core i7-4510U"
            ],
            "5th Gen (Broadwell)": [
                "Core i7-5600U",
                "Core i7-5557U"
            ],
            "6th Gen (Skylake)": [
                "Core i7-6700HQ",
                "Core i7-6500U",
                "Core i7-6600U"
            ],
            "7th Gen (Kaby Lake)": [
                "Core i7-7700HQ",
                "Core i7-7500U"
            ],
            "8th Gen (Kaby Lake-R/Coffee/U-Y/H)": [
                "Core i7-8550U",
                "Core i7-8650U",
                "Core i7-8750H",
                "Core i7-8850H",
                "Core i7-8565U",
                "Core i7-8500Y"
            ],
            "9th Gen (Coffee Lake-H)": [
                "Core i7-9850H",
                "Core i7-9750H"
            ],
            "10th Gen (Ice Lake-U / Comet Lake-U/H)": [
                "Core i7-1065G7",
                "Core i7-1068NG7",
                "Core i7-10710U",
                "Core i7-10510U",
                "Core i7-10875H",
                "Core i7-10750H"
            ],
            "11th Gen (Tiger Lake-U/H35/H45)": [
                "Core i7-1185G7",
                "Core i7-1165G7",
                "Core i7-11370H",
                "Core i7-11375H",
                "Core i7-11800H"
            ],
            "12th Gen (Alder Lake-U/P/H/HX)": [
                "Core i7-12700H",
                "Core i7-12650H",
                "Core i7-1260P",
                "Core i7-1255U"
            ],
            "13th Gen (Raptor Lake-U/P/H/HX)": [
                "Core i7-13700H",
                "Core i7-13620H",
                "Core i7-1360P",
                "Core i7-1355U"
            ],
            "14th Gen (Raptor Lake Refresh - H/HX/U)": [
                "Core i7-14700HX",
                "Core i7-14700H",
                "Core i7-150U"
            ]
        },
        "Core i5": {
            "1st Gen (Arrandale/Clarksfield)": [
                "Core i5-580M",
                "Core i5-560M",
                "Core i5-540M",
                "Core i5-520M",
                "Core i5-460M",
                "Core i5-450M",
                "Core i5-430M",
                "Core i5-540UM",
                "Core i5-520UM",
                "Core i5-430UM",
                "Core i5-520E"
            ],
            "2nd Gen (Sandy Bridge)": [
                "Core i5-2540M",
                "Core i5-2520M",
                "Core i5-2450M",
                "Core i5-2430M",
                "Core i5-2410M",
                "Core i5-2557M"
            ],
            "3rd Gen (Ivy Bridge)": [
                "Core i5-3380M",
                "Core i5-3360M",
                "Core i5-3320M",
                "Core i5-3337U",
                "Core i5-3317U"
            ],
            "4th Gen (Haswell)": [
                "Core i5-4310M",
                "Core i5-4300M",
                "Core i5-4200H",
                "Core i5-4210U",
                "Core i5-4200U"
            ],
            "5th Gen (Broadwell)": [
                "Core i5-5257U",
                "Core i5-5300U",
                "Core i5-5200U"
            ],
            "6th Gen (Skylake)": [
                "Core i5-6300HQ",
                "Core i5-6200U"
            ],
            "7th Gen (Kaby Lake)": [
                "Core i5-7300HQ",
                "Core i5-7200U"
            ],
            "8th Gen (Kaby Lake-R/Coffee/U-Y/H)": [
                "Core i5-8250U",
                "Core i5-8265U",
                "Core i5-8300H",
                "Core i5-8200Y"
            ],
            "9th Gen (Coffee Lake-H)": [
                "Core i5-9400H",
                "Core i5-9300H"
            ],
            "10th Gen (Ice Lake-U / Comet Lake-U/H)": [
                "Core i5-1035G7",
                "Core i5-1035G4",
                "Core i5-1035G1",
                "Core i5-1030G7",
                "Core i5-10210U",
                "Core i5-10500H",
                "Core i5-10300H"
            ],
            "11th Gen (Tiger Lake-U/H35/H45)": [
                "Core i5-1145G7",
                "Core i5-1135G7"
            ],
            "12th Gen (Alder Lake-U/P/H/HX)": [
                "Core i5-12500H",
                "Core i5-12450H",
                "Core i5-1240P",
                "Core i5-1235U"
            ],
            "13th Gen (Raptor Lake-U/P/H/HX)": [
                "Core i5-13500H",
                "Core i5-1340P",
                "Core i5-1335U"
            ],
            "14th Gen (Raptor Lake Refresh - H/HX/U)": [
                "Core i5-14500H",
                "Core i5-120U"
            ]
        },
        "Core i3": {
            "1st Gen (Arrandale/Clarksfield)": [
                "Core i3-390M",
                "Core i3-380M",
                "Core i3-370M",
                "Core i3-350M",
                "Core i3-330M",
                "Core i3-380UM",
                "Core i3-330UM"
            ],
            "2nd Gen (Sandy Bridge)": [
                "Core i3-2350M",
                "Core i3-2330M",
                "Core i3-2310M",
                "Core i3-2367M"
            ],
            "3rd Gen (Ivy Bridge)": [
                "Core i3-3120M",
                "Core i3-3110M",
                "Core i3-3227U",
                "Core i3-3217U"
            ],
            "4th Gen (Haswell)": [
                "Core i3-4100M",
                "Core i3-4000M",
                "Core i3-4030U",
                "Core i3-4010U"
            ],
            "5th Gen (Broadwell)": [
                "Core i3-5010U",
                "Core i3-5005U"
            ],
            "6th Gen (Skylake)": [
                "Core i3-6100U",
                "Core i3-6006U"
            ],
            "7th Gen (Kaby Lake)": [
                "Core i3-7100U",
                "Core i3-7020U"
            ],
            "8th Gen (Kaby Lake-R/Coffee/U-Y/H)": [
                "Core i3-8130U",
                "Core i3-8145U"
            ],
            "10th Gen (Ice Lake-U / Comet Lake-U/H)": [
                "Core i3-1005G1",
                "Core i3-10110U"
            ],
            "11th Gen (Tiger Lake-U/H35/H45)": [
                "Core i3-1125G4",
                "Core i3-1115G4"
            ],
            "12th Gen (Alder Lake-U/P/H/HX)": [
                "Core i3-1220P",
                "Core i3-1215U"
            ],
            "13th Gen (Raptor Lake-U/P/H/HX)": [
                "Core i3-1315U"
            ]
        },
        "Other": {
            "8th Gen (Kaby Lake-R/Coffee/U-Y/H)": [
                "Core m3-8100Y"
            ]
        },
        "Core i9": {
            "9th Gen (Coffee Lake-H)": [
                "Core i9-9980HK",
                "Core i9-9880H"
            ],
            "10th Gen (Ice Lake-U / Comet Lake-U/H)": [
                "Core i9-10980HK"
            ],
            "11th Gen (Tiger Lake-U/H35/H45)": [
                "Core i9-11900H",
                "Core i9-11980HK"
            ],
            "12th Gen (Alder Lake-U/P/H/HX)": [
                "Core i9-12900HX",
                "Core i9-12950HX",
                "Core i9-12900H"
            ],
            "13th Gen (Raptor Lake-U/P/H/HX)": [
                "Core i9-13980HX",
                "Core i9-13950HX",
                "Core i9-13900HX",
                "Core i9-13900H"
            ],
            "14th Gen (Raptor Lake Refresh - H/HX/U)": [
                "Core i9-14900HX"
            ]
        },
        "Core Ultra": {
            "Core Ultra 1st gen (Meteor Lake - H/U)": [
                "Core Ultra 9 185H",
                "Core Ultra 7 165H",
                "Core Ultra 7 155H",
                "Core Ultra 7 164U",
                "Core Ultra 5 135H",
                "Core Ultra 5 125H",
                "Core Ultra 5 134U"
            ]
        }
    },
    "Apple": {
        "M1": {
            "Apple Silicon": [
                "M1",
                "M1 Pro",
                "M1 Max",
                "M1 Ultra"
            ]
        },
        "M2": {
            "Apple Silicon": [
                "M2",
                "M2 Pro",
                "M2 Max",
                "M2 Ultra"
            ]
        },
        "M3": {
            "Apple Silicon": [
                "M3",
                "M3 Pro",
                "M3 Max",
                "M3 Ultra"
            ]
        }
    }
};

export default CPU_DATA_GEN;
